import gql from 'graphql-tag';
import { doMutation } from '../api';

export const QUERY_GET_VIDEO_ANALYSES = gql`
  query getVideoAnalyses($personId: ID!) {
    getVideoAnalyses(personId: $personId) {
      id
      title
      date_created
      analyses {
        id
        date_created
        date_updated
        buildingBlocks
        surveys {
          id
          date_created
          analyseId
          buildBlockId
          index
          last
          finished
          score
        }
        timeRange
        finished
      }
      video {
        date_created
        s3
        thumbs {
          id
          date_created
          s3
        }
      }
      sharedWith {
        id
        firstname
        lastname
        email
      }
      sharedFrom {
        id
        firstname
        lastname
        email
      }
    }
  }
`;

export const QUERY_GET_VIDEO_ANALYSE = gql`
  query getVideoAnalyse($videoAnalyseId: ID!) {
    getVideoAnalyse(videoAnalyseId: $videoAnalyseId) {
      id
      title
      video {
        date_created
        s3
        thumbs {
          id
          date_created
          s3
        }
      }
    }
  }
`;

export const QUERY_GET_ANALYSE = gql`
  query getAnalyse($analyseId: ID!) {
    getAnalyse(analyseId: $analyseId) {
      id
      date_created
      date_updated
      buildingBlocks
      annotations {
        id
        date_created
        text
        time
        person {
          id
          firstname
          lastname
          email
        }
      }
      surveys {
        id
        date_created
        buildBlockId
        sapId
        index
        last
        finished
        score
      }
      timeRange
      finished
    }
  }
`;

export const MUTATION_ADD_ANALYSE = gql`
  mutation addAnalyse(
    $videoAnalyseId: ID
    $buildingBlocks: [Int]
    $timeRange: Int
    $finished: Boolean
  ) {
    addAnalyse(
      input: {
        videoAnalyseId: $videoAnalyseId
        buildingBlocks: $buildingBlocks
        timeRange: $timeRange
        finished: $finished
      }
    ) {
      id
    }
  }
`;

export const MUTATION_EDIT_ANALYSE = gql`
  mutation editAnalyse(
    $id: ID!
    $videoAnalyseId: ID
    $buildingBlocks: [Int]
    $timeRange: Int
    $finished: Boolean
  ) {
    editAnalyse(
      input: {
        id: $id
        videoAnalyseId: $videoAnalyseId
        buildingBlocks: $buildingBlocks
        timeRange: $timeRange
        finished: $finished
      }
    ) {
      id
    }
  }
`;

export const MUTATION_FINISH_ANALYSE = gql`
  mutation editAnalyse($id: ID!, $finished: Boolean) {
    editAnalyse(input: { id: $id, finished: $finished }) {
      id
    }
  }
`;

export const MUTATION_SHARE_ANALYSE = gql`
  mutation shareVideoAnalyse($videoAnalyseId: ID!, $email: String!) {
    shareVideoAnalyse(videoAnalyseId: $videoAnalyseId, email: $email)
  }
`;

export const MUTATION_UNSHARE_ANALYSE = gql`
  mutation unshareVideoAnalyse($videoAnalyseId: ID!, $email: String!) {
    unshareVideoAnalyse(videoAnalyseId: $videoAnalyseId, email: $email)
  }
`;

export const MUTATION_ADD_ANNOTATION = gql`
  mutation addAnnotation($analyseId: ID!, $text: String, $time: Float) {
    addAnnotation(input: { analyseId: $analyseId, text: $text, time: $time }) {
      id
      text
      time
    }
  }
`;

export const MUTATION_EDIT_ANNOTATION = gql`
  mutation editAnnotation($id: ID!, $text: String, $time: Float) {
    editAnnotation(input: { id: $id, text: $text, time: $time }) {
      id
      text
      time
    }
  }
`;

export const MUTATION_ADD_SURVEY = gql`
  mutation addSurvey(
    $analyseId: String!
    $buildBlockId: Int
    $index: Int
    $last: Boolean
    $finished: Boolean
    $score: Int
    $sapId: String
  ) {
    addSurvey(
      input: {
        analyseId: $analyseId
        buildBlockId: $buildBlockId
        index: $index
        last: $last
        finished: $finished
        score: $score
        sapId: $sapId
      }
    ) {
      id
      buildBlockId
      index
      last
      finished
      score
      sapId
    }
  }
`;

export const addAnnotation = async (variables, refetchQueries) => {
  return new Promise(async (resolve, reject) => {
    const mutation = MUTATION_ADD_ANNOTATION;
    return await doMutation({
      mutation,
      variables,
      refetchQueries,
      update: (cache, { data, data: { addAnnotation } }) => {
        if (addAnnotation && addAnnotation.id) {
          resolve(addAnnotation);
        }
      }
    });
  });
};

export const updateAnnotation = async (variables, refetchQueries) => {
  return new Promise(async (resolve, reject) => {
    const mutation = MUTATION_EDIT_ANNOTATION;
    return await doMutation({
      mutation,
      variables,
      refetchQueries,
      update: (cache, { data, data: { editAnnotation } }) => {
        if (editAnnotation && editAnnotation.id) {
          resolve(editAnnotation);
        }
      }
    });
  });
};

export const deleteAnnotation = async (variables, refetchQueries) => {
  return new Promise(async (resolve, reject) => {
    const mutation = MUTATION_ARCHIVE_ANNOTATION;
    return await doMutation({
      mutation,
      variables,
      refetchQueries,
      update: (cache, { data, data: { archiveAnnotation } }) => {
        if (archiveAnnotation) {
          resolve(archiveAnnotation);
        }
      }
    });
  });
};

export const finishAnalyse = async (variables, refetchQueries) => {
  return new Promise(async (resolve, reject) => {
    const mutation = MUTATION_FINISH_ANALYSE;
    return await doMutation({
      mutation,
      variables,
      refetchQueries,
      update: (cache, { data, data: { editAnalyse } }) => {
        if (editAnalyse && editAnalyse.id) {
          resolve(true);
        }
      }
    });
  });
};

export const finishSurvey = async (variables, refetchQueries) => {
  return new Promise(async (resolve, reject) => {
    const mutation = MUTATION_ADD_SURVEY;
    return await doMutation({
      mutation,
      variables,
      refetchQueries,
      update: (cache, { data, data: { addSurvey } }) => {
        if (addSurvey && addSurvey.id) {
          resolve(addSurvey);
        }
      }
    });
  });
};

export const MUTATION_REMOVE_VIDEO_ANALYSE = gql`
  mutation archiveVideoAnalyse($videoAnalyseId: ID!) {
    archiveVideoAnalyse(videoAnalyseId: $videoAnalyseId)
  }
`;

export const MUTATION_ARCHIVE_ANNOTATION = gql`
  mutation archiveAnnotation($annotationId: ID!) {
    archiveAnnotation(annotationId: $annotationId)
  }
`;

export const MUTATION_REMOVE_ANALYSE = gql`
  mutation archiveAnalyse($analyseId: ID!) {
    archiveAnalyse(analyseId: $analyseId)
  }
`;
